import styled, { css } from "styled-components";

export const SwitcherOuterContainer = styled.div`
  box-sizing: border-box;
  display: block;
`;

export const SwitcherInnerContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  padding: ${({ padding }) => padding};
  margin: ${({ childGap }) => `calc((${childGap} / 2) * -1)`};
  ${({ constrainMobile }) =>
    constrainMobile && `max-width: 100%; margin-left: 0; margin-right: 0;`}

  > * {
    flex-grow: 1;
    ${({ maxChildrenOnly, breakpoint, childGap }) =>
      !maxChildrenOnly
        ? `flex-basis: calc((${breakpoint} - (100% - ${childGap})) * 999);`
        : ``};
    ${({ childGap }) => `margin: calc(${childGap} / 2);`}
    ${({ constrainMobile }) =>
      constrainMobile && `margin-left: 0; margin-right: 0;`}
  }

  ${({ largeChild, largeChildSize }) =>
    largeChild && largeChildSize
      ? `> :nth-child(${largeChild}) {
      flex-grow: ${largeChildSize};
    }`
      : ``}

  ${({ maxChildren }) =>
    maxChildren
      ? `> :nth-last-child(${maxChildren +
          1}), > :nth-last-child(${maxChildren + 1}) ~ * {
      flex-basis: 100%;
    }`
      : ``}

  ${({ extraStyles }) =>
    css`
      ${extraStyles}
    `}
`;
